import { render } from "./PhraseComponent.vue?vue&type=template&id=5bd6c3a7"
import script from "./PhraseComponent.vue?vue&type=script&lang=js"
export * from "./PhraseComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__